import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/FreightQuotation/components/SectionCallToAction/SectionCallToAction.module.scss';

const cn = classNames.bind(styles);

const SectionCallToAction = (): ReactElement => {
  return (
    <section className={cn('cta')}>
      <div className={cn('container')}>

        <div className={cn('cta__heading-container')}>
          <h2 className={cn('cta__heading')}>
            Take Freight Documentation One Step Further
          </h2>
          <p className={cn('cta__description')}>
            ERP System lets freight forwarders auto-fill booking forms,
            generate commercial documents instantly, store shipment files securely,
            and sync all documents with customer records.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionCallToAction;